import { render, staticRenderFns } from "./handover.vue?vue&type=template&id=2ee083dc&"
import script from "./handover.vue?vue&type=script&lang=js&"
export * from "./handover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports